import { Link } from 'react-router-dom';
import { styled, Theme } from '@mui/material';
import { CoreTypography } from '@youscience/core';

// TODO add color to library
const linkHoverBg = '#EBF6F7';

export const sxStyles = {
  schoolsBg: {
    // TODO add color to library
    backgroundColor: '#F9F9F9',
  },
  headSectionWrap: (theme: Theme) => ({
    borderBottom: `1px solid ${theme.palette.grey['300']}`,
  }),
  headSectionInner: {
    paddingBottom: '1.5rem',
  },
  navBarInfo: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '624px',
    color: theme.palette.common.black,
  }),
  actionPanel: {
    display: 'flex',
  },
  exploreByTitle: {
    marginRight: '1.5rem',
  },
  mainSectionWrap: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: '1.75rem',
  },
  fullSizeBlock: {
    width: '100%',
    height: '100%',
  },
  spinnerInner: {
    '& > span:first-of-type': {
      display: 'block',
      margin: '3rem auto',
    },
  },
};

export const StyledNavBar = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginBottom: '2.5rem',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
}));

export const StyledNavBarTitle = styled(CoreTypography)(({ theme }) => ({
  marginTop: '1rem',
  marginBottom: '1.5rem',

  [theme.breakpoints.up('xs')]: {
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
  },
}));

export const StyledSwitcherWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'start',
  marginTop: '0.5rem',
  flexDirection: 'column',

  [theme.breakpoints.up('xs')]: {
    alignItems: 'center',
    flexDirection: 'row',
  },
}));

export const StyledExploreByTitle = styled(CoreTypography)(({ theme }) => ({
  marginTop: '3rem',
  marginRight: 0,
  marginBottom: '1rem',

  [theme.breakpoints.up('xs')]: {
    marginTop: 0,
    marginRight: '1.5rem',
    marginBottom: 0,
  },
}));

export const StyledSwitcher = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '2px',
  fontWeight: 600,
}));

export const StyledSchoolsLink = styled(Link)(({ theme }) => ({
  padding: '0.438rem 1.25rem',
  color: theme.palette.primary.main,

  '&:hover': {
    backgroundColor: linkHoverBg,
  },
}));

export const StyledMajorsLink = styled(Link)(({ theme }) => ({
  padding: '0.438rem 1.75rem',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,

  '&:hover': {
    cursor: 'default',
  },
}));

export const StyledFavoritesLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '160px',
  fontWeight: 600,
  fontSize: theme.typography.button.fontSize,
  padding: '0.5rem',
  border: `1px solid ${theme.palette.primary.main}`,
  borderRadius: '2px',
  color: theme.palette.primary.main,
  backgroundColor: linkHoverBg,

  '& > svg:first-of-type': {
    marginRight: '0.625rem',
  },
}));

export const StyledMajorsCardsWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  justifyContent: 'initial',
  gap: '2rem',

  [theme.breakpoints.down('md')]: {
    gap: '2rem 3rem',
  },

  [theme.breakpoints.down('sm')]: {
    justifyContent: 'center',
  },
}));

export const StyledProgressWrap = styled('div')(({ theme }) => ({
  position: 'absolute',
  left: '50%',
  transform: 'translate(0%, -50%)',
}));
